export const dayts = {
  timestamp(dateString: string): number | null {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return null;
    }
    return date.getTime();
  },
  format(timestamp: number, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
    if (!timestamp) {
      return;
    }
    const date = new Date(timestamp);
    const year = String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
  },
  // 传入 UTC 0 时间 → 自动转成北京时间
  utcToLocal(utcTimeStr) {
    const utcDate = new Date(utcTimeStr + ' UTC'); // 标记这是UTC时间
    return utcDate; // 自动变成你当前时区时间
  },

  utcToLocalFormat(utcTimeStr, format: string = 'YYYY-MM-DD HH:mm:ss') {
    const utcDate = new Date(utcTimeStr + ' UTC'); // 标记这是UTC时间
    const timestamp = utcDate.getTime();
    return dayts.format(timestamp, format); // 自动变成你当前时区时间
  },
};

export default dayts;

/**
 * 格式化日期为 yyyymmdd
 */
export function formatTradingDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return +`${year}${month}${day}`;
}

/**
 * 获取 开始偏移 到 结束偏移 之间的**所有连续日期**
 * @param {number} startOffset - 开始天数偏移（负=往前，正=往后）
 * @param {number} endOffset - 结束天数偏移
 * @returns {string[]} 连续每一天的 yyyymmdd 数组
 */
export function getTradingDateRangeByArray(startOffset, endOffset) {
  const today = new Date();
  const result = [];

  // 统一处理方向，自动支持从小到大、从大到小
  const min = Math.min(startOffset, endOffset);
  const max = Math.max(startOffset, endOffset);

  // 循环每一天，加入数组
  for (let i = min; i <= max; i++) {
    const tempDate = new Date(today);
    tempDate.setDate(today.getDate() + i);
    result.push(formatTradingDate(tempDate));
  }

  return result;
}

// 格式化成年-月-日 时:分:秒（去掉毫秒）
export function formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 格式化时间：去掉微秒，保留 年月日 时分秒
 * @param {string} timeStr - 如 "2026-04-10 07:54:54.000000"
 * @returns {string} 如 "2026-04-10 07:54:54"
 */
export function formatTimeString(timeStr: string) {
  if (!timeStr) return '';
  // 匹配到小数点前面的所有内容（直接截断微秒）
  return timeStr.split('.')[0] || '';
}

/**
 * 格式化日期：yyyyMMdd → yyyy-MM-dd
 * @param {string} str - 如 "20260410"
 * @returns {string} 如 "2026-04-10"
 */
export function formatYYYYMMDD(str: string) {
  if (!str) return '';
  const y = String(str).slice(0, 4);
  const m = String(str).slice(4, 6);
  const d = String(str).slice(6, 8);
  return `${y}-${m}-${d}`;
}

/**
 * 从 8 位日期字符串（如 20260402）中提取年/月/日
 * @param {string|number} dateStr - 日期字符串/数字，如 20260402
 * @param {string} part - 要提取的部分：year|month|day，默认 year
 * @returns {number} 提取后的数字
 */
export function extractDate(dateStr, part = 'year') {
  // 统一转成字符串，去掉非数字字符（兼容带点/空格的格式）
  const str = String(dateStr).replace(/\D/g, '');

  // 按位置截取
  switch (part) {
    case 'year':
      return Number(str.slice(0, 4));
    case 'month':
      return Number(str.slice(4, 6));
    case 'day':
      return Number(str.slice(6, 8));
    default:
      throw new Error('part 只能是 year / month / day');
  }
}
